import { AnchorButton } from '@/common/helios/AnchorButton';
import generateEvTaxCreditLink from '@/ev-tax-credit/utils/generateEvTaxCreditLink';
import {
  RightContainer,
  GreenContainer,
  TopLeftContainer,
  BottomContainer,
  VehicleTileImage,
  HeroSection
} from './Hero.styles';

export default function Hero() {
  return (
    <HeroSection>
      <GreenContainer>
        <TopLeftContainer>
          <h1 className="t-brand-sm sm:t-brand-lg">
            Save up to $4,000 with the Used EV Tax Credit
          </h1>

          <p className="t-body-md sm:t-body-xl">
            The Used Electric Vehicle (EV) Federal Tax Credit can help you save
            up to $4,000 on your next pre-owned electric car.
          </p>

          <p className="t-body-md sm:t-body-xl">
            Coming soon: Carvana will make it easier to save by applying these
            tax credits to eligible vehicles at checkout. The federal used EV
            tax credit could help you get the EV you want for less.
          </p>

          <p className="t-body-sm">
            Note: The IRS refers to the used EV tax credit as the
            “previously-owned clean vehicle credit.” We’ll refer to it as the
            “used EV tax credit” for ease of use.
          </p>

          <AnchorButton
            href={generateEvTaxCreditLink()}
            size="lg"
            className="w-full sm:w-fit"
            data-analytics-id="Hero - Shop Eligible Vehicles"
          >
            Shop Eligible Vehicles
          </AnchorButton>
        </TopLeftContainer>
        <RightContainer>
          <VehicleTileImage />
        </RightContainer>
      </GreenContainer>
      <BottomContainer>
        <VehicleTileImage />
      </BottomContainer>
    </HeroSection>
  );
}
